<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main.vue'
import baseMixin from '@/mixins/baseMixin'
import BookingDisputeList from '@/components/disputes/disputes-list.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Layout,
    BookingDisputeList,
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  mixins: [baseMixin],
  computed: {
    compTitle() {
      return 'Booking Disputes'
    },
  },
  async created() {
    await this.initialiseStaff()
    await this.initialiseDisputes()
  },
  methods: {
    ...mapActions({
      initialiseStaff: 'staff/initialiseStaff',
      initialiseDisputes: 'disputes/initialise',
    }),
  },
}
</script>

<template>
  <Layout>
    <BasePageTitle
      :title="compTitle"
      :subtitle="'Resolve pending booking disputes'"
    />
    <BookingDisputeList />
  </Layout>
</template>
